import { ChemicalLabel } from './chemical-label.model';

/** A label PDF on an EPA chemical. The hub keeps EPA and ADN chemical labels in one table with one shape. */
export class EpaChemicalLabel extends ChemicalLabel {}
